import React, { Component } from 'react';
import { connect } from 'react-redux';
import Navigation from '../../components/Navigation/Navigation';
import PhoneNumber from '../../components/PhoneNumber/PhoneNumber';
import { withRouter }  from 'react-router-dom';
import withBackgroundImage from '../../HOC/withBackgroundImage';

import { Container, Row, Col } from 'reactstrap';

import './RatesFees.scss';

class RatesFees extends Component {
  constructor(props) {
    super(props);

    this.onClickBackward = this.onClickBackward.bind(this);
    this.onClickForward = this.onClickForward.bind(this);
  }
  onClickForward(event) {
    event.preventDefault();
    this.props.history.replace('/PersonalInfo/Name');
  }
  onClickBackward() {
    this.props.history.replace('/GetStarted');
  }
  render() {
    let fragment;

    if (this.props.card.tpc === "VI") {
      fragment = <p>Please note these premium cards can impose higher acceptance costs on merchants.</p>        
    }

    return (
      <div className="rates-fees">
        <h1>Fees and important information about Vancity enviro™ Visa* cards</h1>
        <div className="rates-fees-container">
        <div className="rates-fees">
            {fragment}
            <p>The following summary information is effective June 2, 2022. For more information, please call <PhoneNumber value="1-800-611-8472" /> or visit vancity.com/VisaAgreements.</p>
            <Container>
              <Row>
                <Col xs="3">Initial Credit Limit </Col>
                <Col xs="9">
                  <p>Your initial credit limit will appear in the package that accompanies your Visa Card. Your current credit limit will appear on your statements and on your Visa Account.</p></Col>
              </Row>
              <Row>
                <Col xs="3">Annual Interest Rate(s)</Col>
                <Col xs="9">
                  <p>Your interest rate will depend on your Visa Card:</p>
                  <Container>
                    <Row>
                      <Col xs="9">Visa Card</Col>
                      <Col xs="3">Interest Rate</Col>
                    </Row>
                    <Row>
                      <Col xs="9">Vancity enviro Classic* with Vancity Rewards&trade;</Col>
                      <Col xs="3">19.50%</Col>
                    </Row>
                    <Row>
                      <Col xs="9">Vancity enviro Classic Low Interest Rate plus Vancity Rewards</Col>
                      <Col xs="3">11.25%</Col>
                    </Row>
                    <Row>
                      <Col xs="9">Vancity enviro Classic Low Interest Rate (no Vancity Rewards)</Col>
                      <Col xs="3">11.25%</Col>
                    </Row>
                    <Row>
                      <Col xs="9">Vancity enviro Gold&trade; with Vancity Rewards</Col>
                      <Col xs="3">19.50%</Col>
                    </Row>
                    <Row>
                      <Col xs="9">Vancity enviro Gold Low Interest Rate plus Vancity Rewards</Col>
                      <Col xs="3">11.25%</Col>
                    </Row>
                    <Row>
                      <Col xs="9">Vancity enviro Gold Low Interest Rate (no Vancity Rewards)</Col>
                      <Col xs="3"> 11.25%</Col>
                    </Row>
                    <Row>
                      <Col xs="9">Vancity enviro Visa Infinite*</Col>
                      <Col xs="3">19.50%</Col>
                    </Row>
                    <Row>
                      <Col xs="9">Vancity enviro Visa Infinite Privilege*</Col>
                      <Col xs="3">19.50%</Col>
                    </Row>                    
                  </Container>
                </Col>
              </Row>
              <Row>
                <Col xs="3">Interest-free Grace Period</Col>
                <Col xs="9">
                  <p><b>21 days</b></p>
                  <p>You will benefit from an interest-free grace period of 21 days on new purchases and fees appearing
                  on your statement. The 21-day grace period is the period between the last day of your statement
                  period and the payment due date. The payment due date for your statement period appears on your
                  current statement. If you pay off the balance showing on your statement in full by the payment due
                  date, no interest will be payable on all new purchases that appear on your statement for the first
                  time. If you do not pay off the balance appearing on your statement in full by the payment due date,
                  interest will be payable on all purchases appearing on the statement and is charged from the
                  transaction date of each purchase.</p>
                  <p>There is no interest-free grace period on cash advances, balance transfers and amounts written
                  on a Visa Cheque. Interest will be charged on these types of transactions from the date of the
                  transaction.</p>
                </Col>
              </Row>              
              <Row>
                <Col xs="3">Minimum Payment</Col>
                <Col xs="9">
                  <p>You must make at least the minimum payment by the payment due date on your current statement.
                  If you do not make the minimum payment by the payment due date, you may not be able to use your
                  Visa Card(s) until you do. Your minimum payment is calculated as follows:</p>
                  <Container>
                    <Row>
                      <Col xs="6">
                        <p><b>Vancity enviro Classic Visa Card</b></p>
                        <p>The sum of:</p>
                        <ul>
                          <li>$10 or 3% of the unpaid balance shown on
                          your statement, whichever is higher</li>
                          <li>any amount by which your balance exceeds
                          your credit limit</li>
                          <li>any previous unpaid amounts</li>
                        </ul>
                        <p>If the unpaid balance shown on your statement
                        is ever less than $10, your minimum payment
                        will be the amount of your unpaid balance.</p>
                      </Col>
                      <Col xs="6">
                        <p>
                          <b>
                            Vancity enviro Gold Visa card,
                            <br />
                            Vancity enviro Visa Infinite card, or
                            <br />
                            Vancity enviro Visa Infinite Privilege card
                          </b>
                        </p>
                        <p>The sum of:</p>
                        <ul>
                          <li>$50 or 3% of of the unpaid balance shown
                          on your statement, whichever is higher</li>
                          <li>any amount by which your balance exceeds
                          your credit limit</li>
                          <li>any previous unpaid amounts</li>
                        </ul>
                        <p>If the unpaid balance shown on your statement
                        is ever less than $50, your minimum payment
                        will be the amount of your unpaid balance.</p>
                      </Col>
                    </Row>
                  </Container>
              </Col>
              </Row>              
              <Row>
                <Col sm="3" xs="4">Foreign Currency Conversion Transactions</Col>
                <Col sm="9" xs="8">
                  <p><b>Exchange rate</b></p>
                  <p>We will charge you in Canadian currency if you use your Visa Card to make transactions in a foreign
                  currency. We will convert transactions in U.S. dollars directly to Canadian dollars at the Visa exchange rate
                  in effect at the time we process your transaction (which may be different from the date you made the
                  transaction). For other foreign currencies, the transaction is first converted to U.S. dollars and then to
                  Canadian dollars at the exchange rates in effect at the time we process your transaction.</p>
                  
                  <p><b>2.5% Administration fee</b></p>
                  <p>When the transaction is processed, we will add a 2.5% administration fee in addition to the Visa exchange
                  rate. The conversion rate shown on your statement includes the Visa exchange rate and the administration
                  fee we charge you.</p>
                  <p>Any refunds you receive on the Visa Account in a foreign currency will also be converted into Canadian
                  dollars in the same way.</p>
                </Col>
              </Row>              
              <Row>
                <Col xs="3">Annual Fees</Col>
                <Col xs="9">
                <Container>
                    <Row>
                      <Col xs="9">Visa Card</Col>
                      <Col xs="3">Annual Fee</Col>
                    </Row>
                    <Row>
                      <Col xs="9">Vancity enviro Classic with Vancity Rewards</Col>
                      <Col xs="3">no annual fee</Col>
                    </Row>
                    <Row>
                      <Col xs="9">Vancity enviro Classic Low Interest Rate plus Vancity Rewards</Col>
                      <Col xs="3">$50</Col>
                    </Row>
                    <Row>
                      <Col xs="9">Vancity enviro Classic Low Interest Rate (no Vancity Rewards)</Col>
                      <Col xs="3">$25</Col>
                    </Row>
                    <Row>
                      <Col xs="9">Vancity enviro Gold with Vancity Rewards</Col>
                      <Col xs="3">$99</Col>
                    </Row>
                    <Row>
                      <Col xs="9">Vancity enviro Gold Low Interest Rate plus Vancity Rewards</Col>
                      <Col xs="3">$145</Col>
                    </Row>
                    <Row>
                      <Col xs="9">Vancity enviro Gold Low Interest Rate (no Vancity Rewards)</Col>
                      <Col xs="3">$45</Col>
                    </Row>
                    <Row>
                      <Col xs="9">Vancity enviro Visa Infinite</Col>
                      <Col xs="3"> $120</Col>
                    </Row>
                    <Row>
                      <Col xs="9">Vancity enviro Visa Infinite additional card (issued to Authorized User)</Col>
                      <Col xs="3">First card $0<br/>Each additional card is $50 per card</Col>
                    </Row>
                    <Row>
                      <Col xs="9">Vancity enviro Visa Infinite Privilege (members)</Col>
                      <Col xs="3">$245</Col>
                    </Row>
                    <Row>
                      <Col xs="9">Vancity enviro Visa Infinite Privilege (non-members)</Col>
                      <Col xs="3">$395</Col>
                    </Row>
                    <Row>
                      <Col xs="9">Vancity enviro Visa Infinite Privilege additional card (issued to Authorized User)</Col>
                      <Col xs="3">First card $0<br />Each additional card is $50 per card</Col>
                    </Row>
                  </Container>                
                  <p>The annual fee for Visa Infinite, Visa Infinite Privilege and other Visa Cards with Vancity Rewards is charged on your first statement after opening the Visa Account (whether or not your Visa Card is activated). 
                  The annual fee for Visa Cards with no Vancity Rewards is charged following the first transaction on the Visa Account. 
                  Once we charge the first annual fee, we will charge you the annual fee in that same month every year. 
                  If the type of Visa Card changes and the annual fee changes as a result, the new annual fee will be charged on the first statement after the change, or following the first transaction (if there was no previous transaction on the Visa Account and if the new type of Visa Card is with no Vancity Rewards), and then in that same month every year.</p>
                </Col>
              </Row>              
              <Row>
                <Col xs="3">Other Fees</Col>
                <Col xs="9">
                  <p>Charged on the day the transaction or event occurs, unless otherwise specified:</p>
                  <p><b>Cash Advance: $4</b> for each Cash Advance in Canada or internationally.</p>
                  <p><b>Payment not accepted due to Not Sufficient Funds (NSF): $45</b> if you make a payment on your Visa Account that is not accepted because your cheque bounces or any other type of payment method is not accepted.</p>
                  <p><b>Over credit limit: $25</b> will be charged if you go over your credit limit at any time during your statement period. We will only charge this fee one time in a statement period, even if you go over your credit limit more than one time in that statement period.</p>
                  <p><b>Extra copy of your statement: $2 per statement</b> if you request a copy of an old statement. There is no charge for a copy of the current statement or for electronic statements you are able to access online.</p>
                  <p><b>Extra copy of sales receipt: $5</b> if you request a copy of the sales receipt for any of your purchases.</p>
                  <p><b>Return of positive credit balance: $10</b> if we return to you any over-payment you’ve made on your Visa Account.</p>
                  <p><strong>Annual Account maintenance: $10</strong> or the full amount of the positive credit balance, whichever is lower is charged to your account when there’s been no transactions or activity for 12 consecutive months and there is a positive credit balance.</p>
                </Col>
              </Row>                        
            </Container>
            <p className="footnote">enviro (TM), enviro Gold (TM), Vancity Rewards (TM) and Make Good Money (TM) are trademarks of Vancouver City Savings Credit Union.</p>
            <p className="footnote">*Trademark of Visa Int., used under license</p>
          </div>
        </div>
        <a href="/Content/Vancity-Visa_Fees-and-Important-Info.pdf" target="_blank">Download a copy</a>
        <Navigation onClickForward={this.onClickForward} onClickBackward={this.onClickBackward} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ...state
})


export default connect(mapStateToProps) (withRouter(withBackgroundImage("rates-fees")(RatesFees)));


// WEBPACK FOOTER //
// ./src/containers/RatesFees/RatesFees.js